import React, { useEffect, useState, useRef, useCallback } from 'react';
import clsx from 'clsx';
import {
  Grid,
  makeStyles,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';

import Input from '../components/Input/Input';
import Button from '../components/Button/Button';
import Dialog from '../components/Dialog/Dialog';
import CodeInputCustom from '../components/CodeInput/index';
import {
  eligibilityCheck, otpValidate, resendOtp,
} from '../data-manager/info';


import DateComponent from '../components/DateComponent/DateComponent';
import DateComponentCustom from '../components/DateComponent';
import {
  restrictSpecialCharacters,
} from '../utils.ts';


import { ArrowRight } from '@/assets/images/arrow';
import Helper from '../helper/helper';

const useSetUpVerficationStyles = makeStyles(theme => ({
  root: {},
  container: {
    padding: '0 10px',
    paddingTop: '80px',
    minHeight: 'calc(100vh - 363px)',
    position: 'relative',
    '@media (min-width: 1600px)': {
      maxWidth: '1440px',
    },
    '@media (max-width: 767px)': {
      padding: '30px 0 0',
    },
  },
  title: {
    fontSize: theme.typography.$fzH2,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '32px',
    letterSpacing: 'normal',
    marginBottom: '30px',
    color: theme.palette.$title,
  },
  mt40: {
    marginTop: '40px',
  },
  mt20: {
    marginTop: '20px',
  },
  resentOtp: {
    lineHeight: theme.typography.$lhH6,
    fontSize: theme.typography.$fzH6,
    color: theme.palette.$uploadBorderHover,
    marginTop: '24px',
    '& span': {
      cursor: 'pointer',
    },
  },
  headerModal: {
    marginBottom: '16px',
    fontSize: theme.typography.$fzH2,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: theme.typography.$lhH2,
    letterSpacing: 'normal',
  },
  description: {
    fontSize: theme.typography.$fzH4,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '28px',
    letterSpacing: 'normal',
    color: theme.palette.$description,
    '@media (max-width: 767px)': {
      fontSize: theme.typography.$fzH6,
      '& br': {
        display: 'none',
      },
    },
  },
  buttonWrapper: {
    // display: 'flex',
    position: 'absolute',
    bottom: 0,
    right: 0,
    textAlign: 'right',
    alignItems: 'center',
    margin: '0 auto',
    '@media (max-width: 767px)': {
      display: 'block',
    },
    '@media (min-width: 1600px)': {
      maxWidth: '1440px',
    },
    '& Button': {
      minWidth: '118px',
      height: '52px'
    },
  },
  textBlur: {
    lineHeight: theme.typography.$lhH6,
    fontSize: theme.typography.$fzH6,
    color: theme.palette.$lineGrey,
    marginTop: '24px',
  },
  iconWarning: {
    verticalAlign: 'middle',
    marginBottom: '2px',
    marginRight: '4px',
  },
}), 'set-up-verification');

const SetupVerification = ({
  classes,
  goToOnlineTradingPage,
  goToDigitalBankPage,
  goToSystemErrorPage,
  goToVarifiedErrorPage,
  saveFormData,
  showLoading
}) => {
  const verficationClass = useSetUpVerficationStyles();
  const dispatch = useDispatch();
  const [formRedux] = useState(
    useSelector((state) => state.form),
  );
  const [nricErrorText, setNricErrorText] = useState('');

  const [times, setTimes] = useState(0);
  const [isRetryAllowed, setIsRetryAllowed] = useState(true);
  const [dialogId, setDialogId] = useState(null);
  // otp values start
  const [codeValueArr, setCodeValueArr] = useState(['', '', '', '', '', '']);
  const [passwordArr, setPasswordArr] = useState([false, false, false, false, false, false]);
  const [otpErrored, setOtpErrored] = useState(false);
  const [otpErrorMessage, setOtpErrorMessage] = useState('');
  const [focused, setFocused] = useState(false);
  const [resendOTPRes, setResendOTPRes] = useState({});

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);
  const inputRef6 = useRef(null);
  const inputRefs = [inputRef1, inputRef2, inputRef3, inputRef4, inputRef5, inputRef6];
  // otp values ends

  const [custInfo, setCustInfo] = useState({
    authorizationTypeCode: '',
    authorizationId: '',
    transactionId: '',
    mobile: '',
    eligible: false,
    accessCode: true,
  });


  const [verification, setVerification] = useState({
    nric: '',
    date: '',
    month: '',
    year: '',
  });

  const getVerification = (name, value, error) => setVerification({
    ...verification,
    [name]: value,
  });

  const DATA_FORMAT = 'dd/MM/yyyy';
  const invalidDateMessage = 'Invalid Date Format';
  const [selectedDate, setSelectedDate] = useState(null);
  const [dateErrored, setDateErrored] = useState(false);
  const [dateErrorMessage, setDateErrorMessage] = useState('Invalid Date Format');
  const [isDisableVerified, setIsDisableVerified] = useState(true);
  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (date && date.toString() !== 'Invalid Date') {
      const newDate = new Date(date);
      setVerification({
        ...verification,
        date: newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate().toString(),
        month: newDate.getMonth() + 1 < 10 ? `0${newDate.getMonth() + 1}` : (newDate.getMonth() + 1).toString(),
        year: newDate.getFullYear(),
      });
    }
  };

  const verifyDate = (date) => {
    if (date === '' || date === '--') {
      setDateErrored(false);
    } else {
      const newDate = new Date(date);
      const isDateValid = Helper.isDateValid(newDate);
      if (!isDateValid) {
        setDateErrored(true);
      } else {
        const isDateBefore = Helper.isDateBefore(newDate);
        const isDateAfter = Helper.isDateAfter(newDate);
        if (isDateBefore && isDateAfter) {
          setDateErrored(false);
        } else {
          setDateErrored(true);
        }
      }
    }
  };
  const handleDateChangeCustom = useCallback((name, date) => {
    setVerification({
      ...verification,
      [name]: date,
    });
    let fullate = '';
    if (name === 'year') {
      fullate = `${date}-${verification.month}-${verification.date}`;
      verifyDate(fullate);
    }
  });

  useEffect(() => {
    setIsDisableVerified(verification.nric && verification.date && verification.month && verification.year && !nricErrorText && !dateErrored);
  }, [verification, nricErrorText, dateErrored]);

  const CountDown = () => {
    const time = setTimeout(() => {
      // eslint-disable-next-line no-plusplus
      if (times < 1) {
        clearTimeout(time);
      } else {
        setTimes(times - 1);
      }
    }, 1000);
  };

  // otp methods start
  const resetCodeInputValues = () => {
    const newCodeValueArr = ['', '', '', '', '', ''];
    const newPasswordArr = [false, false, false, false, false, false];
    setCodeValueArr(newCodeValueArr);
    setPasswordArr(newPasswordArr);
    setOtpErrored(false);
    setOtpErrorMessage('');
    const inputDom = inputRef6.current;
    inputDom.blur();
    setFocused(false);
  };

  const focusInput = (index) => {
    const nextInput = inputRefs[index].current;
    nextInput.focus();
    nextInput.setSelectionRange(1, 1);
  };

  const setCodeInputValue = (inputValue, index) => {
    const newCodeArr = [...codeValueArr];
    newCodeArr[index] = inputValue;
    setCodeValueArr(newCodeArr);
    if (inputValue !== '') {
      setTimeout(() => {
        const newPwdArr = [...passwordArr];
        newPwdArr[index] = true;
        setPasswordArr(newPwdArr);
        if (index < 5) {
          focusInput(index + 1);
        }
      }, 100);
    } else {
      setTimeout(() => {
        const newPwdArr = [...passwordArr];
        newPwdArr[index] = false;
        setPasswordArr(newPwdArr);
        if (index > 0) {
          focusInput(index - 1);
        }
      }, 100);
    }
  };

  const codeFocus = () => {
    setFocused(true);
  };
  const clickOutside = () => {
    setFocused(false);
  };
  // otp methods end

  const closeDialog = () => {
    setDialogId(false);
    resetCodeInputValues();
  };

  const optResend = () => {
    const { timing } = formRedux.form;
    const { transactionId, authorizationId, authorizationTypeCode } = custInfo;
    resetCodeInputValues();
    showLoading(true);
    setTimes(timing);
    resendOtp(transactionId, authorizationId, authorizationTypeCode).then(resp => {
      showLoading(false);
      resetCodeInputValues();
      CountDown();
      if (resp && resp.data && resp.status === 'SUCCESS') {
        const {
          // eslint-disable-next-line no-shadow
          authorizationId, authorizationTypeCode, isRetryAllowed, authorizationReference
        } = resp.data;
        setIsRetryAllowed(isRetryAllowed);
        setCustInfo({
          ...custInfo,
          authorizationTypeCode,
          authorizationId,
        });
        setResendOTPRes({
          authorizationTypeCode,
          authorizationId,
          authorizationReference
        })
      }
    });
  };

  const optRequest = (isResendOtp) => {
    const { caseId, timing } = formRedux.form;
    const {
      nric,
      date,
      month,
      year,
    } = verification;
    const dateBirth = `${year}${month}${date}`;
    setTimes(timing);
    showLoading(!isResendOtp && true);
    eligibilityCheck(caseId, nric, dateBirth).then(resp => {
      showLoading(false);
      setNricErrorText('');
      if (resp && resp.data) {
        const {
          isEligible, smsEnable, hasAccessCode, transactionId, triedCount, authorizationId, authorizationTypeCode,
        } = resp.data;
        if (!resp.errorCode && isEligible) {
          setDialogId(true);
          CountDown();
          const txnId = (smsEnable && transactionId) || (!smsEnable && '2021043019242672176');
          setCustInfo({
            ...custInfo,
            authorizationTypeCode,
            authorizationId,
            transactionId: txnId,
            mobile: resp.data.mobile,
            eligible: isEligible,
            accessCode: hasAccessCode,
          });
          if (triedCount >= 3) {
            goToVarifiedErrorPage();
          }
          if (isResendOtp) {
            resetCodeInputValues();
          }
        } else if (resp.data.errCode) {
          switch (resp.data.errCode) {
            case '2':
            case '5':
            case '6':
            case '7':
            case '4':
              setNricErrorText('Please ensure the information entered is accurate.');
              break;
            default:
              // eslint-disable-next-line no-undef
              goToSystemErrorPage();
              break;
          }
        }
      } else if (resp.error.code) {
        // eslint-disable-next-line default-case
        switch (resp.error.code) {
          case 'TAM2007':
            setNricErrorText('Please ensure the information entered is accurate.');
            break;
          case 'TAM2015':
            setNricErrorText('Please ensure the information entered is accurate.');
            break;
          case 'TAM2014':
            goToVarifiedErrorPage();
            break;
          default:
            // eslint-disable-next-line no-undef
            goToSystemErrorPage();
            break;
        }
      } else {
        // eslint-disable-next-line no-undef
        goToSystemErrorPage();
      }
    });
  };

  const verifyOtp = () => {
    const { caseId } = formRedux.form;
    const { transactionId, eligible } = custInfo;
    showLoading(true);
    const otp = codeValueArr.join('');
    const data = {
      caseId, 
      otp, 
      transactionId,
      ...resendOTPRes
    }
    otpValidate(data).then(resp => {
      showLoading(false);
      if ((!resp.error && resp.data.status === 'SUCCESS')) {
        closeDialog();
        const newFormData = { ...formRedux.form, custInfo };
        dispatch(saveFormData(newFormData));
        // if (eligible) {
        //   goToOnlineTradingPage();
        // } else if (accessCode) {
        //   goToDigitalBankPage();
        // } else {
        //   goToSetupBothPage();
        // }
        if (eligible) {
          goToOnlineTradingPage();
        } else {
          goToHasCompletedPage();
        }
      } else {
        if (resp && resp.data && resp.data.description) {
          resetCodeInputValues();
          setOtpErrored(true);
          if (resp.data?.description.includes('CAUTH-40010')) {
            setOtpErrorMessage('The OTP does not match.');
          }
          if (resp.data?.description.includes('CAUTH-40008')) {
            setOtpErrorMessage('The OTP does not match.');
          }
        }
        if (resp && resp.data && resp.data?.triedCount >= 3) {
          goToVarifiedErrorPage();
        }
        if (resp && resp.error && resp.error.code) {
          switch (resp.error.code) {
            case 'TAM2018':
              goToSystemErrorPage();
              break;
            default:
              // eslint-disable-next-line no-undef
              goToSystemErrorPage();
              break;
          }
        }
        if (resp && resp.error && resp.error?.message) {
          setOtpErrored(true);
          setOtpErrorMessage('Service is unavaliable, please try it again later');
        }
      }
    });
  };

  useEffect(() => {
    setSelectedDate(`${verification.year}-${verification.month}-${verification.date}`);
  }, [verification.date, verification.month, verification.year]);

  useEffect(() => {
    const lastValue = codeValueArr[5];
    if (lastValue !== '') {
      verifyOtp();
    }
  }, [codeValueArr]);

  useEffect(() => {
    if (times > 0) {
      CountDown();
    }
  }, [dialogId && times]);

  const contentMessage = () => (
    <div className={verficationClass.mt40}>
      <div className={verficationClass.headerModal}>
        Verify it’s you
      </div>
      <CodeInputCustom
        ref={inputRefs}
        label="We will send a One-Time Password (OTP) to your mobile number if the details you provided match those in our records."
        title="Enter the OTP to proceed"
        passwordArr={passwordArr}
        setValue={setCodeInputValue}
        code={codeValueArr}
        errored={otpErrored}
        errorMessage={otpErrorMessage}
        focused={focused}
        codeFocus={codeFocus}
        clickOutside={clickOutside}
      />
      {times !== 0 && <div className={clsx(verficationClass.textBlur)}>Request a new OTP in 3 mins</div>}
      {
        (isRetryAllowed && times === 0) && (
          <div className={verficationClass.resentOtp}>
            <span onClick={() => { optResend(); }} aria-hidden="true">I need a new OTP</span>
          </div>
        )
      }
    </div>
  );
  return (
    <>
      <div className={verficationClass.title}>
        {formRedux.form && formRedux.form.dynamicContent.verification_page.TITLE}
      </div>
      <div className={verficationClass.description}>
        {formRedux.form && formRedux.form.dynamicContent.verification_page.CONTENT_TEXT}
      </div>
      <Grid container className={verficationClass.mt20}>
        <Grid
          item lg={4} md={4} sm={6} xs={12}
        >
          <Input
            label="Last 4 characters of NRIC/Passport number"
            maxLength={4}
            placeholder=""
            preventSpecialCharacters={restrictSpecialCharacters}
            value={verification.nric}
            // checkOnChange
            type="text"
            size="large"
            kind="nric"
            errorText={nricErrorText}
            setErrorText={setNricErrorText}
            getValue={value => {
              getVerification('nric', value.value, value.error);
            }}
            message="eg. 123A"
          />
        </Grid>
      </Grid>
      {/* <Grid container className={verficationClass.mt40}>
        <Grid item lg={4} md={4} sm={6} xs={12}>
          <DateComponent
            dateFormat={DATA_FORMAT}
            onChange={handleDateChange}
            value={selectedDate}
            invalidDateMessage={invalidDateMessage}
            message="Date, month, year"
          />
        </Grid>
      </Grid> */}
      <Grid container className={verficationClass.mt40}>
        <Grid item lg={4} md={4} sm={6} xs={12}>
          <DateComponentCustom
            dateFormat={DATA_FORMAT}
            onChange={handleDateChangeCustom}
            value={selectedDate}
            invalidDateMessage={invalidDateMessage}
            message="Date, month, year"
            errored={dateErrored}
            errorMessage={dateErrorMessage}
            verifyDate={verifyDate}
          />
        </Grid>
      </Grid>
      <div className={clsx(verficationClass.buttonWrapper, verficationClass.mt40)}>
        <Button
          backgroundClass="bgGunmetalBluegrey"
          onClick={() => {
            optRequest(false);
          }}
          disabled={!isDisableVerified}
        >
          Next
          <ArrowRight size="24" color="currentColor" />
        </Button>
      </div>
      <Dialog
        isOpen={dialogId}
        onRequestClose={closeDialog}
      >
        {contentMessage()}
      </Dialog>

    </>
  );
};

export default SetupVerification;
